import messages from './netbank-login-disabled-lang.json';
import branchAtmWidgetWrapper from '../../branch-atm-widget-wrapper/branch-atm-widget-wrapper.vue';
export default {
	data() {
		return {};
	},
	props: {
		atmBranchSearchUrl: {
			required: true
		},
		gmapsApiKey: {
			type: String,
			required: true
		}
	},
	components: {
		branchAtmWidgetWrapper
	},
	i18n: { messages },
	created() {
		const BRANCH_ATM_WIDGET_WC_SRC = '/static/branchatmlocator/widget/branch-atm-widget.wc.min.js';
		const script = document.createElement('script');
		script.src = BRANCH_ATM_WIDGET_WC_SRC;
		document.head.appendChild(script);
	}
};
